import { BodyText } from '@unmind/design-system';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Pill = styled(Link)`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 12px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.background.card};
  align-self: flex-start;
  width: auto;
  box-sizing: border-box;
  height: 42px;

  transition:
    transform 100ms ease-in-out,
    opacity 100ms ease-in-out;

  &:active {
    transform: scale(0.95);
    opacity: 0.6;
  }

  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.08);
  }
`;

export const IconWrap = styled.div`
  display: inline-flex;
  line-height: 0;
`;

export const Label = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize16],
  weight: theme.typography.fontWeights.semiBold,
  color: theme.colors.text.primary,
}))``;
